import { createReducer } from 'reduxsauce';

import { Action } from '.';
import { Props } from '../../containers/Alert';

export interface OptionsContract {
  title: string;
  buttonDescription: string;
  description: string;
  icon?: any;
  theme?: string;
  buttonPrimaryDescription?: string;
  buttonPrimaryAction?: any;
  loading?: boolean;
}

/* Types --------------- */
export enum Types {
  OPEN = 'modal/OPEN',
  CLOSE = 'modal/CLOSE',
  LOADING = 'modal/LOADING',
  TITLE = 'modal/TITLE',
}

/* Typings --------------- */
type ActionType<P> = Action<Types, P>;

export type StateRedux = Props;

/* Reducers ------------ */
const initialState: StateRedux = {
  open: false,
  title: '',
  buttonDescription: '',
  description: '',
  icon: '',
  backgroundColor: 'NORMAL',
  buttonPrimaryDescription: '',
  buttonPrimaryAction: null,
  loading: false,
  timerAction: null,
};

const Modal = createReducer<StateRedux, ActionType<StateRedux>>(initialState, {
  [Types.OPEN]: (state, action) => ({
    ...state,
    ...initialState,
    open: true,
    ...action.payload,
  }),
  [Types.CLOSE]: state => ({
    ...state,
    ...initialState,
    open: false,
  }),
  [Types.LOADING]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [Types.TITLE]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
});

/* Actions ------------- */
export const Actions = {
  open: (options: OptionsContract): ActionType<OptionsContract> => ({
    type: Types.OPEN,
    payload: options,
  }),

  close: (): ActionType<any> => ({
    type: Types.CLOSE,
  }),

  setLoading: (loading: boolean): ActionType<any> => ({
    type: Types.LOADING,
    payload: { loading },
  }),

  setTitle: (title: string): ActionType<any> => ({
    type: Types.TITLE,
    payload: { title },
  }),
};

export default Modal;
